import ShoppingBagCheckmark from '../../src/legacy/ShoppingBagCheckmark.tsx';
export default ShoppingBagCheckmark;
